import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface DeleteLoanParams {
  id: string;
}

export interface DeleteLoanResponse {
  success: boolean;
  message?: string;
}

const _mockType: DeleteLoanResponse = {
  success: true,
  message: 'Loan deleted successfully',
};

const deleteLoan: MutationFunction<
  DeleteLoanResponse,
  DeleteLoanParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockType);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<DeleteLoanResponse>(
    `/loans/${args.id}`,
    {
      method: 'DELETE',
    },
  );

  if (response.data) return response.data;
  throw new Error('Failed to delete loan');
};

export default deleteLoan;
